import Doc from "./Doc";

function DocIn(props) {
  return (
    <Doc group={1} {...props} />
  );
}

export default DocIn;
